import { call, put, select } from 'redux-saga/effects'
import { isNil } from 'ramda'
import VideoActions from 'Redux/VideoRedux'
import { SelectionSelectors } from 'Redux/SelectionRedux'
import { VideoRespTransform } from 'Transforms/Video'
import { BuildErrorMsg } from './ApiHelpers'

export function * onProjectVideosRequest (api, action) {
  const resp = yield call(api.getProjectVideos, action.projectId)
  if (resp.ok) {
    yield put(VideoActions.videosListSuccess(VideoRespTransform(resp.data)))
  } else {
    yield put(VideoActions.videosListFailure(BuildErrorMsg(resp)))
  }
}

export function * onVideoVersionsRequest (api, action) {
  const resp = yield call(
    api.getVideoVersions, action.videoId)
  if (resp.ok) {
    yield put(VideoActions.videosVersionsSuccess(resp.data))
  } else {
    yield put(VideoActions.videosVersionsFailure(BuildErrorMsg(resp)))
  }
}

export function * onVideosCreateRequest (api, action) {
  const resp = yield call(api.createVideo, action.createParams)
  if (resp.ok) {
    yield put(VideoActions.videosCreateSuccess(resp.data))
    const project = yield select(SelectionSelectors.activeProject)
    yield put(VideoActions.videosListRequest(project.id))
  } else {
    yield put(VideoActions.videosCreateFailure(BuildErrorMsg(resp)))
  }
}

export function * onVideosUpdateRequest (api, action) {
  const resp = yield call(api.updateVideo, action.id, action.updateParams)
  if (resp.ok) {
    yield put(VideoActions.videosUpdateSuccess(resp.data))
    if (!isNil(resp.data.status)) {
      yield put(VideoActions.videosSetStatus(resp.data.status))
    }
  } else {
    yield put(VideoActions.videosUpdateFailure(BuildErrorMsg(resp)))
  }
}

export function * onVideosDeleteRequest (api, action) {
  const resp = yield call(api.deleteVideo, action.id)
  if (resp.ok) {
    yield put(VideoActions.videosDeleteSuccess(resp.data))
    const project = yield select(SelectionSelectors.activeProject)
    yield put(VideoActions.videosListRequest(project.id))
  } else {
    yield put(VideoActions.videosDeleteFailure(BuildErrorMsg(resp)))
  }
}

export function * onVideosUnversionRequest (api, action) {
  const resp = yield call(api.unversionVideo, action.id)
  if (resp.ok) {
    yield put(VideoActions.videosUnversionSuccess(resp.data))
    const project = yield select(SelectionSelectors.activeProject)
    yield put(VideoActions.videosListRequest(project.id))
  } else {
    yield put(VideoActions.videosUnversionFailure(BuildErrorMsg(resp)))
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/VideoSagas.js